import styled from 'styled-components';

export const StyledLink = styled.a`
  text-decoration: underline;
  padding-left: 0.25rem;

  &:hover {
    text-decoration: none;
  }
`;
